module.exports = __webpack_public_path__ + "img/score_0.234eef9e.png";